export default __webpack_public_path__ + "static/media/quantityEntry.e1a7c228.svg";